<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M23.2495 20.75V3.25C23.2495 1.875 22.1245 0.75 20.7495 0.75H3.24951C1.87451 0.75 0.749512 1.875 0.749512 3.25V20.75C0.749512 22.125 1.87451 23.25 3.24951 23.25H20.7495C22.1245 23.25 23.2495 22.125 23.2495 20.75ZM7.62451 13.875L10.7495 17.6375L15.1245 12L20.7495 19.5H3.24951L7.62451 13.875Z" fill="#109CF1"/>
  </svg>

</template>

<script>
  export default {
    name: 'imgDummy'
  }
</script>
